import { Button, emptyFragment } from '@execonline-inc/execonline-ui';
import { Stripe } from '@stripe/stripe-js';
import { fromNullable } from 'maybeasy';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../../Translations';
import { PaymentCheckoutFormState } from '../../../Common';
import { CheckoutKind, confirmButtonColor } from '../CheckoutKind';

interface Props {
  stripe: Stripe;
  state: PaymentCheckoutFormState;
  checkout: CheckoutKind;
}

const submitPaymentDisabled = (stripe: Stripe): boolean => fromNullable(stripe).isNothing();

function PaymentCheckoutButton({ stripe, state, checkout }: Props) {
  const color = confirmButtonColor(checkout);
  switch (state.kind) {
    case 'waiting':
      return emptyFragment();
    case 'confirming-payment':
      return (
        <Button
          className="mt-6"
          color={color}
          size="md"
          fullWidth
          isLoading
          disabled
          data-intercom-target="payment-confirm-and-pay-button"
        >
          <T kind="Loading..." />
        </Button>
      );
    case 'payment-declined':
    case 'ready-for-payment-confirmation':
      return (
        <Button
          type="submit"
          className="mt-6"
          size="md"
          color={color}
          fullWidth
          data-intercom-target="payment-confirm-and-pay-button"
          disabled={submitPaymentDisabled(stripe)}
        >
          <T kind="Confirm And Pay" />
        </Button>
      );
  }
}

export default observer(PaymentCheckoutButton);
